import React from "react";
import { Tabs } from "antd";
import DescriptionTab from "./descriptionTab.js";
import FunctionsTab from "./functionsTab.js";
import StructureTab from "./structureTab.js";
import styles from "./description.module.css";

const TabPane = Tabs.TabPane;

function callback(key) {
  console.log(key);
}

class DescriptionSlide extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <Tabs defaultActiveKey="1" type="card" onChange={callback}>
          <TabPane tab="ОПИСАНИЕ" key="1">
            <DescriptionTab />
          </TabPane>
          <TabPane tab="ФУНКЦИИ" key="2">
            <div style={{ paddingLeft: "2vw" }}>
              <FunctionsTab />
            </div>
          </TabPane>
          <TabPane tab="СТРУКТУРА" key="3">
            <div style={{ paddingLeft: "2vw" }}>
              <StructureTab />
            </div>
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default DescriptionSlide;
